module.exports = __webpack_public_path__ + "static/media/LogicLever1_4_2.73e0394a.png";